import { theme } from "../../theme";
export const logProcessStyle = {
    whiteBoard:{
        height: "100%",
        background: "#fff",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding:"20px",
      },


} as const;
